import React, { useState,useEffect,useRef,useCallback } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/DashboardStyle.module.css';
import DashboardTitle from "./DashboardTitle";
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";
//import { AiOutlinePlusCircle } from "react-icons/ai";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate  } from 'react-router-dom';
import { useSelector } from 'react-redux';
import constants from '../../services/constants'
import { getUserData ,
    getCountryListFormData,
    getCategoryListFormData,
    getStateListByCountryId,
    getCityListByStateId} from "../../services/routes.services";

const isObject = (value) => {
    return value && typeof value === 'object' && !Array.isArray(value);
};
const EditProfile = () => {
    const selectRef = useRef(null);
    const navigate = useNavigate();
    const selectStateRef = useRef(null);
    const { user,token } = useSelector((state) => state.auth);
    //const [userData ,setUserData] =useState('');
    const [submitError, setSubmitError] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [profession,setProfession] = useState([]);
    // const [categoryData ,setCategoryData] =useState([]);
    // const [countryData ,setCountryData] =useState([]);

    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const [errors, setErrors] = useState({});
    const [profileImgPreview, setProfileImgPreview] = useState(require('../../assest/images/list-img01.png'));
    const [formData, setFormData] = useState({
        name: '',
        last:'',
        gender: '',
        batch: '',
        phone: '',
        dob: '',
        school: '',
        rollno: '',
        houseinmayo: '',
        country: '',
        state: '',
        city: '',
        pincode: '',
        email: '',
        orgname: '',
        categoryId:'',
        designation: '',
        jobDescription: '',
    });

    useEffect(() => {
        getCountryListFormData()
            .then((res) => {
                setCountries(res.data.countries);
            })
            .catch((error) => {
                console.log(error);
            }); 

        
        if(formData.country.id){
            getStateListByCountryId(formData.country.id)
            .then((res) => {
                setStates(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
        }
        if(formData.state.id){
            getCityListByStateId(formData.state.id)
            .then((res) => {
                setCities(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
        }

        getCategoryListFormData()
        .then((res) => {
            setProfession(res.data.categories);
        })
        .catch((error) => {
            console.log(error);
        });
            
    }, [formData.state.id,formData.country.id]);

    

    const handleCountryChange = (e) => {
        //const selectedCountry = e.target.value;
        const selectedOption = selectRef.current.options[selectRef.current.selectedIndex];
        const selectedCountry = selectedOption.id;
        alert(selectedCountry)
        setFormData({ ...formData, country: selectedOption.value, state: '', city: '' });
        setErrors({ ...errors, [e.target.name]: '' });
        //setSubmitError('');
        setStates([]);
        setCities([]);
         // Fetch states based on selected country
         getStateListByCountryId(selectedCountry)
        .then((res) => {
            setStates(res.data);
        })
        .catch((error) => {
            console.log(error);
        });
    };

    const handleStateChange = (e) => {
        //const selectedState = e.target.value;
        const selectedOption = selectStateRef.current.options[selectStateRef.current.selectedIndex];
        const selectedState = selectedOption.id;
        setFormData({ ...formData, state: selectedOption.value, city: '' });
        setErrors({ ...errors, [e.target.name]: '' });
       // setSubmitError('');
        setCities([]);
        // Fetch cities based on selected state
        getCityListByStateId(selectedState)
        .then((res) => {
             setCities(res.data);
        })
        .catch((error) => {
            console.log(error);
        });
    };
    
    const UserDataApi = useCallback(() => {
        // Your API call logic here
        getUserData(user._id, token)
        .then((res) => {
            const alumni  = res.data.alumni;
            const formattedDob = formatDateForInput(alumni.dob);

            
                setFormData({
                name: alumni.name || '',
                last: alumni.last || '',
                gender: alumni.gender || '',
                batch: alumni.batch || '',
                phone: alumni.phone || '',
                dob: formattedDob || '',
                school: alumni.school || '',
                rollno: alumni.rollno || '',
                houseinmayo: alumni.houseinmayo || '',
                country: alumni.country || '',
                state: alumni.state || '',
                city: alumni.city || '',
                pin: alumni.pin || '',
                email: alumni.email || '',
                orgname: alumni.orgname || '',
                categoryId:alumni.category || '',
                designation: alumni.designation || ''
            });
            
            setProfileImgPreview(constants.IMAGE_BASE_URL+'alumni/'+alumni.image)
            //setCategoryData(res.data.categories);
            
        })
        .catch((error) => {
            console.log(error);
        });
      }, [user,token]);
      useEffect(() => {
        UserDataApi()  
    }, [UserDataApi]);
   
    const formatDateForInput = (dateString) => {
  if (!dateString) return '';

  const parsedDate = new Date(dateString);
  if (isNaN(parsedDate)) return ''; // Invalid date check

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(parsedDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};



    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: '' });
        setSubmitError('');
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
            //setFormData({ ...formData, image: file });
            const reader = new FileReader();
            reader.onloadend = () => {
                setProfileImgPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const validate = () => {
        let formErrors = {};

        if (!formData.name) formErrors.firstName = "First Name is required";
        if (!formData.last) formErrors.lastName = "Last Name is required";
        if (!formData.gender) formErrors.gender = "Gender is required";
        if (!formData.batch) formErrors.batch = "Batch is required";
        if (!formData.phone) formErrors.mobileNo = "Mobile No is required";
        if (!formData.dob) formErrors.dateOfBirth = "Date of Birth is required";
        if (!formData.school) formErrors.school = "School is required";
        if (!formData.rollno) formErrors.schoolRollNo = "School Roll No. is required";
        if (!formData.houseinmayo) formErrors.lastHouseInMayo = "Last House In Mayo is required";
        if (!formData.country) formErrors.country = "Country is required";
        if (!formData.state) formErrors.state = "State is required";
        if (!formData.city) formErrors.city = "City is required";
        if (!formData.pin) formErrors.pincode = "Pincode is required";
        if (!formData.email) {
            formErrors.emailId = "Email Id is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            formErrors.emailId = "Email Id is invalid";
        }
        //if (!formData.jobDescription) formErrors.jobDescription = "Job Description is required";
       // if (!formData.profession) formErrors.profession = "Profession is required";
        if (!formData.orgname) formErrors.organizationName = "Organization Name is required";
        if (!formData.designation) formErrors.designation = "Designation is required";

        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        const formDataToSend = new FormData();
        for (const key in formData) {
            if(key==='country' && isObject(formData[key])){
                formDataToSend.append(key, formData[key]._id);
            }else if(key==='state' && isObject(formData[key])){
                formDataToSend.append(key, formData[key]._id);
            }else if(key==='city' && isObject(formData[key])){
                formDataToSend.append(key, formData[key]._id);
            }else{
                formDataToSend.append(key, formData[key]);
            }
            
        }
        
        if (selectedImage) { // check if imageFile is not the default image
            formDataToSend.append('image', selectedImage);
        }
console.log(formDataToSend,"formDataToSend")
        try {
            const response = await axios.post(constants.API_BASE_URL+'alumni/edit/'+user._id+'/alumni', formDataToSend,{
      headers: {
        Authorization: `Bearer ${token}`, // Include your token here
        'Content-Type': 'application/json', // optional, based on your backend
      },
    });
            setSuccessMessage('User update successfully!');
            setTimeout(() => setSuccessMessage(''), 5000);
            setFormData(formData)
            toast.success('User update successfully!', {
                position: "top-right",
                 
             type: 'success'
         });
            handleExitPage();
        } catch (error) {
            console.error('There was an error saving the user!', error);
            setSubmitError(error.response?.data?.error || 'An error occurred while saving the user');
        }
    };
    const handleExitPage=()=>{
        navigate("/dashboard");
    }
    return (
        <div>
            <DashBoardLeftProfileMenu />
            <div className={'containerStyla ' + Style.Dashboardscreen + " " + Style.BussinesList +" " + Style.EditProForm}>
                <Container>
                    <DashboardTitle title="Edit Profile" membertype="Non Member" />
                    <Row className={Style.space}>
                        <Col>
                            <div className={Style.newFormStyle}>
                                <form id="myform" method="post" noValidate onSubmit={handleSubmit}>
                                    <div className={Style.formContainer}>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>Edit/Add Profile Picture</label>
                                                <div className={Style.addProfileImg}>
                                                    <figure className={Style.profileImg}>
                                                        <img src={profileImgPreview} alt="Profile" />
                                                    </figure>
                                                    <input 
                                                        type='file' 
                                                        className={Style.inputStyle + ' ' + Style.inputFileStyle} 
                                                        name="profilePicture" 
                                                        onChange={handleFileChange} 
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>First Name</label>
                                                <input 
                                                    type='text' 
                                                    className={Style.inputStyle} 
                                                    name="name" 
                                                    value={formData.name} 
                                                    onChange={handleChange} 
                                                />
                                                {errors.firstName && <span className={Style.error}>{errors.firstName}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Last Name</label>
                                                <input 
                                                    className={Style.inputStyle} 
                                                    type='text' 
                                                    name="last" 
                                                    value={formData.last} 
                                                    onChange={handleChange} 
                                                />
                                                {errors.lastName && <span className={Style.error}>{errors.lastName}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Gender</label>
                                                <select 
                                                    className={Style.inputStyle} 
                                                    name="gender" 
                                                    value={formData.gender} 
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select Gender</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                </select>
                                                {errors.gender && <span className={Style.error}>{errors.gender}</span>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>Batch</label>
                                                <select 
                                                    className={Style.inputStyle} 
                                                    name="batch" 
                                                    value={formData.batch} 
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select Batch Year</option>
                                                    {Array.from({ length: 2025 - 1950 + 1 }, (_, index) => {
                                                            const year = 1950 + index;
                                                            return (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                            );
                                                        })}
                                                    {/* Add more options as needed */}
                                                </select>
                                                {errors.batch && <span className={Style.error}>{errors.batch}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Mobile No</label>
                                                <input 
                                                    type='number' 
                                                    className={Style.inputStyle} 
                                                    name="phone" 
                                                    value={formData.phone} 
                                                    onChange={handleChange} 
                                                />
                                                {errors.mobileNo && <span className={Style.error}>{errors.mobileNo}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Date of Birth</label>
                                                <input 
                                                    type='date' 
                                                    className={Style.inputStyle} 
                                                    name="dob" 
                                                    value={formData.dob} 
                                                    onChange={handleChange} 
                                                />
                                                {errors.dateOfBirth && <span className={Style.error}>{errors.dateOfBirth}</span>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>School</label>
                                                <select 
                                                    className={Style.inputStyle} 
                                                    name="school" 
                                                    value={formData.school} 
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select School</option>
                                                    <option value="Mayo Boys">Mayo Boys</option>
                                                    <option value="Mayo Girls">Mayo Girls </option>
                                                    {/* Add more options as needed */}
                                                </select>
                                                {errors.school && <span className={Style.error}>{errors.school}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>School Roll No.</label>
                                                <input 
                                                    type='text' 
                                                    className={Style.inputStyle} 
                                                    name="rollno" 
                                                    value={formData.rollno} 
                                                    onChange={handleChange} 
                                                />
                                                {errors.schoolRollNo && <span className={Style.error}>{errors.schoolRollNo}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Last House In Mayo</label>
                                                <input 
                                                    type='text' 
                                                    className={Style.inputStyle} 
                                                    name="houseinmayo" 
                                                    value={formData.houseinmayo} 
                                                    onChange={handleChange} 
                                                />
                                                {errors.lastHouseInMayo && <span className={Style.error}>{errors.lastHouseInMayo}</span>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>Country</label>
                                                <select ref={selectRef} className={Style.inputStyle} value={formData.country._id} name="country" id="country"  onChange={handleCountryChange}>
                                                    <option>Select Country</option>
                                                    {countries && countries.map(country => (
                                                        <option id={country.id} key={country.id} value={country._id}>{country.name}</option>
                                                    ))}
                                                </select>
                                                {errors.country && <span className={Style.error}>{errors.country}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>State</label>
                                                <select ref={selectStateRef} className={Style.inputStyle} value={formData.state._id} name="state" id="state"  onChange={handleStateChange}>
                                                    <option>Select State</option>
                                                    {states && states.map(state => (
                                                        <option key={state.id} id={state.id} value={state._id}>{state.name}</option>
                                                    ))}
                                                </select>
                                                {errors.state && <span className={Style.error}>{errors.state}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>City</label>
                                                <select className={Style.inputStyle} name="city" id="city"  value={formData.city._id} onChange={handleChange}>
                                                    <option>Select City</option>
                                                    {cities.map(city => (
                                                        <option key={city.id} value={city._id}>{city.name}</option>
                                                    ))}
                                                </select>
                                                {errors.city && <span className={Style.error}>{errors.city}</span>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <div>
                                                    <label>Pincode</label>
                                                    <input 
                                                        type='text' 
                                                        className={Style.inputStyle} 
                                                        name="pin" 
                                                        value={formData.pin} 
                                                        onChange={handleChange} 
                                                    />
                                                    {errors.pincode && <span className={Style.error}>{errors.pincode}</span>}
                                                </div>
                                                <div className={Style.multiCol}>
                                                    <label>Email Id</label>
                                                    <input 
                                                        type='email' 
                                                        className={Style.inputStyle} 
                                                        name="email" 
                                                        value={formData.email} 
                                                        onChange={handleChange} 
                                                    />
                                                    {errors.emailId && <span className={Style.error}>{errors.emailId}</span>}
                                                </div>
                                            </div>
                                            <div className={Style.fromCol2}>
                                                <label>Job Description</label>
                                                <textarea 
                                                    type='text' 
                                                    className={Style.inputStyle} 
                                                    name="jobDescription" 
                                                    value={formData.jobDescription} 
                                                    onChange={handleChange} 
                                                ></textarea>
                                                {errors.jobDescription && <span className={Style.error}>{errors.jobDescription}</span>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>Profession</label>
                                                <select 
                                                    className={Style.inputStyle} 
                                                    name="categoryId" 
                                                    value={formData.categoryId} 
                                                    onChange={handleChange}>
                                                
                                                    <option value="">Select Profession</option>
                                                    {profession.map(prof => (
                                                        <option key={prof._id} value={prof._id}>{prof.name}</option>
                                                    ))}
                                                    {/* Add more options as needed */}
                                                </select>
                                                {errors.profession && <span className={Style.error}>{errors.profession}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Organization Name</label>
                                                <input 
                                                    type='text' 
                                                    className={Style.inputStyle} 
                                                    name="orgname" 
                                                    value={formData.orgname} 
                                                    onChange={handleChange} 
                                                />
                                                {errors.organizationName && <span className={Style.error}>{errors.organizationName}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Designation</label>
                                                <input 
                                                    type='text' 
                                                    className={Style.inputStyle} 
                                                    name="designation" 
                                                    value={formData.designation} 
                                                    onChange={handleChange} 
                                                />
                                                {errors.designation && <span className={Style.error}>{errors.designation}</span>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            {submitError && <p style={{ color: 'red' }}>{submitError}</p>}
                                            {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
                                            <div className={Style.fromCol2 + ' ' + Style.fromBtn}>
                                                <button type="submit" className={Style.subBtn}>Submit</button>
                                                <button type="button" className={Style.clearBtn} onClick={() => setFormData({
                                                    profilePicture: '',
                                                    firstName: '',
                                                    lastName: '',
                                                    gender: '',
                                                    batch: '',
                                                    mobileNo: '',
                                                    dateOfBirth: '',
                                                    school: '',
                                                    schoolRollNo: '',
                                                    lastHouseInMayo: '',
                                                    country: '',
                                                    state: '',
                                                    city: '',
                                                    pincode: '',
                                                    emailId: '',
                                                    jobDescription: '',
                                                    profession: '',
                                                    organizationName: '',
                                                    designation: ''
                                                })}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>              
                                </form>
                            </div>
                        </Col>
                    </Row>
                    <ToastContainer/>
                </Container>
            </div>
        </div>
    );
};

export default EditProfile;
